export var API_ENDPOINT = '/spend';
export var LOADER_KEY = 'spend';
export var REDUCER_KEY = 'spend';